import { render, staticRenderFns } from "./DialogFullSize.vue?vue&type=template&id=03e4cf70&scoped=true&"
import script from "./DialogFullSize.vue?vue&type=script&lang=js&"
export * from "./DialogFullSize.vue?vue&type=script&lang=js&"
import style0 from "./DialogFullSize.vue?vue&type=style&index=0&id=03e4cf70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e4cf70",
  null
  
)

export default component.exports